import React, { Component } from 'react'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Container from 'constructicon/container'
import Section from 'constructicon/section'

class HeaderContainer extends Component {
  constructor (props) {
    super(props)
    this.state = { isTransparent: props.isOverlaid }
    this.handleScroll = throttle(this.handleScroll.bind(this), 100)
  }

  componentDidMount () {
    const { isOverlaid, isSticky } = this.props

    if (isSticky && isOverlaid) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount () {
    if (this.shouldApplyScroll) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll () {
    const scrollPos = window.pageYOffset
    const { isTransparent } = this.state

    if (!isTransparent && scrollPos < 50) {
      this.handleScroll = throttle(this.handleScroll.bind(this), 100)
      this.setState({ isTransparent: true })
    }

    if (isTransparent && scrollPos > 50) {
      this.handleScroll = debounce(this.handleScroll.bind(this), 100)
      this.setState({ isTransparent: false })
    }
  }

  render () {
    const {
      background,
      children,
      classNames,
      foreground,
      isOverlaid,
      isSticky,
      styles
    } = this.props

    const { isTransparent } = this.state

    return (
      <div className={classNames.wrapper}>
        <Section
          tag='header'
          id='header'
          role='banner'
          aria-label='Site header'
          background={isTransparent ? 'transparent' : background}
          foreground={foreground}
          styles={{
            ...styles.root,
            ...(isOverlaid && styles.overlaid),
            ...(isSticky && styles.sticky),
            ...(isTransparent && styles.transparent)
          }}
        >
          <Container>{children}</Container>
        </Section>
      </div>
    )
  }
}

export default withStyles(styles)(HeaderContainer)



// WEBPACK FOOTER //
// ./components/container/Header/HeaderContainer/index.js